'use strict';

$ = jQuery;
/*
Monitora os cliques em "Buscar" que foram feitos no widget.
*/

$('.jc-search-form-home button').on('click', function () {

  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Oferta',
    'eventAction': 'Clique - Buscar',
    'eventLabel': $(this).parents('.jc-search-form-home').find('.brand option:selected').text() + ' - ' + $(this).parents('.jc-search-form-home').find('.model option:selected').text()
  });

  gtag('event', 'Oferta', {
    'eventAction': 'Clique - Buscar',
    'eventLabel': $(this).parents('.jc-search-form-home').find('.brand option:selected').text() + ' - ' + $(this).parents('.jc-search-form-home').find('.model option:selected').text()
  });

  dataLayerEstadao.push({
    'event': 'genericEvent',
    'genericCategory': 'conversao',
    'genericAction': $(this).parents('.jc-search-form-home').find('.brand option:selected').text() + ' ' + $(this).parents('.jc-search-form-home').find('.model option:selected').text(),
    'genericLabel': 'buscar'
  });

  gtag('event', 'conversao', {
    'genericAction': $(this).parents('.jc-search-form-home').find('.brand option:selected').text() + ' ' + $(this).parents('.jc-search-form-home').find('.model option:selected').text(),
    'genericLabel': 'buscar'
  });
});